import { borderWidthBase, borderWidthThin } from "@porsche-design-system/components-react/styles";

const borders = {
    none: 0,
    thin: `${borderWidthThin} solid`,
    base: `${borderWidthBase} solid`,
};

export default borders;
